const GET_DATA_PROP_NAME_DATA_ITEMS = "DataItems";
const DATA_ITEM_TIMESTAMP_PROP_NAME = "reportedTimeEpochSeconds";

const DATA_TYPES_ENERGY = "DATA_TYPES_ENERGY";
const DATA_TYPES_POWER = "DATA_TYPES_POWER";
const DATA_TYPES_DEMAND = "DATA_TYPES_DEMAND";
const DATA_TYPES_REALTIME = "DATA_TYPES_REALTIME";
const DATA_TYPES_COST = "DATA_TYPES_COST";
const ANALYSIS_TYPES_TREND_ANALYSIS = "ANALYSIS_TYPES_TREND_ANALYSIS";
const ANALYSIS_TYPES_ANOMALY_DETECTION= "ANALYSIS_TYPES_ANOMALY_DETECTION";

const DATA_TYPES = {
  ENERGY: DATA_TYPES_ENERGY,
  POWER: DATA_TYPES_POWER,
  DEMAND: DATA_TYPES_DEMAND,
  REALTIME: DATA_TYPES_REALTIME,
  COST: DATA_TYPES_COST
};

const ANALYSIS_TYPES = {
  TREND_ANALYSIS: ANALYSIS_TYPES_TREND_ANALYSIS,
  ANOMALY_DETECTION: ANALYSIS_TYPES_ANOMALY_DETECTION
}

const DATA_COLORS = {
  DEMAND: "#4427A0",
  THRESHOLD: "#144D63",
  OVER_THRESHOLD: "#DC4A17"
};

export { GET_DATA_PROP_NAME_DATA_ITEMS, DATA_ITEM_TIMESTAMP_PROP_NAME, DATA_TYPES, DATA_COLORS, ANALYSIS_TYPES };
